import React, { Fragment, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SliderPlaceholder from './SliderPlaceholder';
import { createPictureEl, renderPicture } from './utils/picture';
import { RATIOS } from './utils/constants';

import styles from './SliderTrackImage.module.scss';

const SliderTrackImage = props => {
  const [imageLoaded, setImageLoaded] = useState(props.noPlaceholder);
  const imgRef = useRef(null);

  const handleLoad = e => {
    if (e.target && document.body.contains(e.target)) {
      setImageLoaded(true);
    }
  };

  useEffect(() => {
    if (props.shouldLoad && !imageLoaded && !props.noPlaceholder) {
      const picture = createPictureEl(
        props.item.src,
        props.item.caption,
        handleLoad
      );

      imgRef.current.insertAdjacentElement('beforeBegin', picture);
      imgRef.current.remove();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.item, props.shouldLoad, props.noPlaceholder]);

  const className = classNames(styles['slider-figure'], {
    [styles['slider-figure--hidden']]: !imageLoaded
  });

  const { showCaption, item } = props;

  return (
    <Fragment>
      {!imageLoaded && <SliderPlaceholder ratio={props.ratio} />}
      <figure className={className}>
        {!item ? null : (
          <Fragment>
            {props.noPlaceholder ? (
              renderPicture(item.src, item.caption)
            ) : (
              <span ref={imgRef} />
            )}
            {showCaption && item.caption && (
              <figcaption>{item.caption}</figcaption>
            )}
          </Fragment>
        )}
      </figure>
    </Fragment>
  );
};

SliderTrackImage.propTypes = {
  item: PropTypes.shape({
    src: PropTypes.string.isRequired,
    caption: PropTypes.string.isRequired
  }).isRequired,
  showCaption: PropTypes.bool,
  shouldLoad: PropTypes.bool,
  ratio: PropTypes.oneOf(Object.values(RATIOS)).isRequired,
  noPlaceholder: PropTypes.bool
};

SliderTrackImage.defaultProps = {
  showCaption: false,
  shouldLoad: false,
  noPlaceholder: false
};

export default SliderTrackImage;
